// src/components/TrustSection.js
import React, { useState, useEffect } from 'react';
import { DASHBOARD_URL } from '../config/urls';
import './TrustSection.css';

const TrustSection = () => {
  const [isMobile, setIsMobile] = useState(false);

  // Detect mobile screen size
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <section className="trust-section">
      <div className="trust-wrap">
        <div className="trust-image">
          <img 
            src="https://images.unsplash.com/photo-1556761175-4b46a572b786?q=80&w=1200"
            alt="Indian business owners discussion"
            loading="lazy"
            decoding="async"
          />
        </div>

        <div className="trust-content">
          <span className="trust-eyebrow">WHY TRUST US</span>
          <h2>
            {isMobile ? (
              <>Built for real people.<br />For real needs.</>
            ) : (
              <>Built for real people.<br />Designed for real financial needs.</>
            )}
          </h2>
          <p>
            {isMobile ? (
              "Lending Mitra partners with regulated institutions to offer transparent, secure loans aligned with your financial well-being."
            ) : (
              "Lending Mitra partners with regulated institutions to offer loans that are transparent, secure, and aligned with your long-term financial well-being, whether for personal needs or business growth."
            )}
          </p>

          <div className="trust-points">
            <div className="trust-point">
              <strong>Transparent Terms</strong>
              <span>{isMobile ? 'Clear terms with no hidden fees.' : 'Clear, fair loan structures with no hidden fees or surprises.'}</span>
            </div>
            <div className="trust-point">
              <strong>Secure & Compliant</strong>
              <span>{isMobile ? 'Partnered with regulated institutions.' : 'Partnering with regulated institutions for your financial safety.'}</span>
            </div>
            <div className="trust-point">
              <strong>Quick Approval</strong>
              <span>{isMobile ? 'Fast processing with minimal docs.' : 'Fast processing with minimal documentation required.'}</span>
            </div>
            <div className="trust-point">
              <strong>Flexible Options</strong>
              <span>{isMobile ? 'Tailored solutions for your needs.' : 'Tailored solutions for your unique financial needs.'}</span>
            </div>
          </div>

          <a href={DASHBOARD_URL} className="trust-cta">Check your eligibility</a>
        </div>
      </div>
    </section>
  );
};

export default TrustSection;
